export default __webpack_public_path__ + "static/media/profile-img.762104b9.png";